/**
 * Season Service
 * Service for fetching season data
 */

import { apiClient } from './apiClient';

export interface Season {
  id: number;
  year: number;
  name?: string; // For display purposes, usually year as string
}

export const seasonService = {
  /**
   * Get all seasons
   */
  async getSeasons(): Promise<Season[]> {
    const response = await apiClient.get('/seasons/');
    return response.data.results || response.data;
  },
};
